import React from 'react';

import { gql } from '@soundxyz/gql-string';
import { AddToQueueMenuItem } from '@components/basics/Dropdowns/MenuItems/AddToQueueMenuItem';
import { AddToShelfMenuItem } from '@components/basics/Dropdowns/MenuItems/AddToShelfMenuItem';
import { CopyLinkMenuItem } from '@components/basics/Dropdowns/MenuItems/CopyLinkMenuItem';
import { ShareMenuItem } from '@components/basics/Dropdowns/MenuItems/ShareMenuItem';
import { ThreeDotsDropdown } from '@components/basics/Dropdowns/ThreeDotsDropdown';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { ChartsThreeDotReleaseInfoFragmentDoc } from '@graphql/reactQuery';
import { useCopy } from '@hooks/useCopy';
import { trackClickEvent } from '@lib/analytics';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ChartsThreeDotReleaseInfo on Release {
    id
    webappUri
    type
    track {
      id
    }
  }
`);

export function ChartCardThreeDotMenu({
  release,
}: {
  release: FragmentType<ChartsThreeDotReleaseInfoFragmentDoc>;
}) {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState<boolean>(false);

  const releaseInfo = getFragment(ChartsThreeDotReleaseInfoFragmentDoc, release);

  const { id, track, webappUri } = releaseInfo;

  const hasAudioAccess = releaseInfo.type !== 'ALBUM';

  const { copy } = useCopy({
    text: webappUri,
    successMessage: 'Link copied to clipboard',
  });

  return (
    <ThreeDotsDropdown
      setIsDropdownOpen={setIsDropdownOpen}
      isDropdownOpen={isDropdownOpen}
      dropdownProps={{
        align: 'end',
        queue: true,
      }}
    >
      <AddToShelfMenuItem releaseId={id} source="Card" />
      <AddToQueueMenuItem
        trackId={track.id}
        disabled={!track.id || !hasAudioAccess}
        emitAnalytics={() => {
          trackClickEvent({
            event: 'Add to Queue Clicked',
            properties: {
              associationId: id,
              associationType: 'Release',
              sourceComponent: 'Chart',
            },
          });
        }}
      />
      <CopyLinkMenuItem onClick={copy} />
      <ShareMenuItem releaseId={id} source="Chart" />
    </ThreeDotsDropdown>
  );
}
